import themeGet from '@styled-system/theme-get';
import styled, { css } from 'styled-components';
import { borderRadius, compose, space } from 'styled-system';
import { borderRadiusAttrs } from '../utils/attrs/borderRadiusAttrs';
import { applySizes, applyVariations, color, colorScheme, textTransform } from '../utils/utils';
const type = props => {
  const badgeColors = {
    blue: {
      backgroundColor: props.theme.colors.blue,
      color: props.theme.colors.white
    },
    lightBlue: {
      backgroundColor: props.theme.colors.lightBlue,
      color: props.theme.colors.darkBlue
    },
    green: {
      backgroundColor: props.theme.colors.green,
      color: props.theme.colors.white
    },
    lightGreen: {
      backgroundColor: props.theme.colors.lightGreen,
      color: props.theme.colors.darkGreen
    },
    red: {
      backgroundColor: props.theme.colors.red,
      color: props.theme.colors.white
    },
    lightRed: {
      backgroundColor: props.theme.colors.lightRed,
      color: props.theme.colors.darkRed
    },
    orange: {
      backgroundColor: props.theme.colors.orange,
      color: props.theme.colors.text
    },
    gray: {
      backgroundColor: props.theme.colors.gray,
      color: props.theme.colors.white
    },
    lightGray: {
      backgroundColor: props.theme.colors.lightGray,
      color: props.theme.colors.text
    }
  };
  return !(props.bg && props.color) && (badgeColors[props.bg] || badgeColors.lightGray);
};
export const sizes = {
  captionSmall: css(["", " padding:2px 2px;"], themeGet('typography.caption')),
  captionMedium: css(["", " padding:", ";"], themeGet('typography.caption'), props => themeGet('space')(props)[1]),
  small: css(["", " padding:3px 3px;"], themeGet('typography.label')),
  medium: css(["", " padding:", ";"], themeGet('typography.captionBold'), props => themeGet('space')(props)[1])
};
const letterSpacing = props => {
  return props.textTransform && props.textTransform !== 'uppercase' ? {
    letterSpacing: themeGet('letterSpacings.normal')(props)
  } : {
    letterSpacing: themeGet('letterSpacings.caps')(props)
  };
};
/**
 * @public
 */
export const Badge = /*#__PURE__*/styled.div.attrs(borderRadiusAttrs).withConfig({
  displayName: "Badge",
  componentId: "sc-1i8al1c-0"
})(["display:inline-block;", ";", ";", " ", " ", " ", " ", " ", ""], ({
  theme
}) => applySizes(sizes, undefined, theme.mediaQueries), applyVariations('Badge'), type, color, colorScheme, textTransform, letterSpacing, props => compose(space, borderRadius)(props));
Badge.displayName = 'Badge';
Badge.defaultProps = {
  size: 'medium',
  px: 2,
  borderRadius: 'full',
  textTransform: 'uppercase'
};